import React, { useState } from "react";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function POWAssessment() {
  const [form, setForm] = useState({
    location: "",
    date: "",
    jobNumber: "",
    picos: "",
    instructions: "",
    training: "",
    ppe: "",
    liveWork: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRadio = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("POW Assessment submitted!");
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />

      <div className="container py-4">
        {/* Back Button - floating to the left of the card */}
        <div className="card shadow-sm rounded-4 p-4">
          <h2
            className="text-center text-white py-2 mb-4 rounded"
            style={{
              backgroundColor: "#8b1634",
              letterSpacing: "1px",
              fontSize: "1.8rem"
            }}
          >
            POW Assessment
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* Location */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">
                  Location / Description of Works
                </label>
                <div style={{ position: "relative" }}>
                  <i
                    className="fa fa-map-marker"
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#8b1634",
                      fontSize: "1.1rem"
                    }}
                  ></i>
                  <input
                    type="text"
                    name="location"
                    value={form.location}
                    onChange={handleChange}
                    placeholder="Enter Location / Description"
                    required
                    className="form-control"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={e => (e.target.style.borderColor = "#8b1634")}
                    onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                  />
                </div>
              </div>

              {/* Date */}
              <div className="col-md-3">
                <label className="form-label fw-semibold text-secondary">
                  Date
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="date"
                    name="date"
                    value={form.date}
                    onChange={handleChange}
                    placeholder="Enter Date"
                    required
                    className="form-control"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "18px",
                      color: "#8b1634"
                    }}
                    onFocus={e => (e.target.style.borderColor = "#8b1634")}
                    onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                  />
                </div>
              </div>

              {/* Job Number */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">
                  Job Number
                </label>
                <div style={{ position: "relative" }}>
                  <i
                    className="fa fa-hashtag"
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#8b1634",
                      fontSize: "1.1rem"
                    }}
                  ></i>
                  <input
                    type="text"
                    name="jobNumber"
                    value={form.jobNumber}
                    onChange={handleChange}
                    placeholder="Enter Job Number"
                    required
                    className="form-control"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={e => (e.target.style.borderColor = "#8b1634")}
                    onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                  />
                </div>
              </div>

              {/* PiCOS */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">
                  Person in Charge of Safety (PiCOS)
                </label>
                <div style={{ position: "relative" }}>
                  <i
                    className="fa fa-user"
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#8b1634",
                      fontSize: "1.1rem"
                    }}
                  ></i>
                  <input
                    type="text"
                    name="picos"
                    value={form.picos}
                    onChange={handleChange}
                    placeholder="Enter PiCOS"
                    required
                    className="form-control"
                    style={{
                      background: "#f7fafd",
                      borderRadius: "10px",
                      border: "1.5px solid #eaf0fe",
                      fontSize: "1.08rem",
                      paddingLeft: "40px"
                    }}
                    onFocus={e => (e.target.style.borderColor = "#8b1634")}
                    onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                  />
                </div>
              </div>
            </div>

            {/* Radio Groups */}
            <div style={{ marginTop: "2rem", marginBottom: "1.2rem" }}>
              {[
                {
                  question:
                    "The Work Party has the relevant job instructions, plans, safety documents & permits for this work.",
                  name: "instructions"
                },
                {
                  question:
                    "The Work Party has the necessary training and/or current authorisations to carry out this work.",
                  name: "training"
                },
                {
                  question:
                    "The Work Party has the necessary PPE & safety equipment and there is an effective means for raising alarm.",
                  name: "ppe"
                },
                {
                  question:
                    "Live working, Re-energisation, Rail & Airside work – Justified/Authorised and checklists completed.",
                  name: "liveWork",
                  options: ["Yes", "No", "N/A"]
                }
              ].map(({ question, name, options }) => (
                <div key={name} className="mb-3">
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#8b1634",
                      fontSize: "1.08rem",
                      marginBottom: "0.7rem"
                    }}
                  >
                    {question}
                  </div>
                  <div className="d-flex gap-4 flex-wrap">
                    {(options || ["Yes", "No"]).map(option => (
                      <label
                        key={option}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          fontWeight: 500,
                          color: "#8b1634"
                        }}
                      >
                        <input
                          type="radio"
                          name={name}
                          value={option}
                          checked={form[name] === option}
                          onChange={() => handleRadio(name, option)}
                          style={{
                            accentColor: "#8b1634",
                            width: "1.3em",
                            height: "1.3em"
                          }}
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <div className="col-12 text-center mt-4">
              <button
                type="submit"
                className="btn btn-lg text-white fw-bold px-5 py-2"
                style={{
                  backgroundColor: "#8b1634",
                  borderRadius: "30px",
                  boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default POWAssessment;
